import { useContext } from 'react';
import { UserContext } from '../contexts/UserContext';

export const useUserState = () => {
  const context = useContext(UserContext);
  
  if (context === undefined) {
    throw new Error('useUserState must be used within a UserProvider');
  }

  const {
    isLoading,
    error,
    data: rawData,
    userData,
    teams,
    organizations,
    permissions,
    refreshUserData,
    clearUserData,
    setUserState
  } = context;

  return {
    // Loading and error states
    isLoading,
    error,

    // Pre-computed data
    userData,
    teams,
    organizations,
    permissions,
    
    // Actions
    refreshUserData,
    clearUserData,
    setUserState,
    
    // Raw data access (if needed)
    rawData
  };
};
